export class AcquirerType {
  public static readonly PAYMENT_SYSTEM_JCC = 'jcc';
  public static readonly PAYMENT_SYSTEM_UFC = 'ufc';
  public static readonly PAYMENT_SYSTEM_CLOUDPAYMENTS = 'cloudpayments';
  public static readonly PAYMENT_SYSTEM_TIPTOPPAY = 'tiptoppay';
  public static readonly PAYMENT_SYSTEM_WEBPAY = 'webpay';
  public static readonly PAYMENT_SYSTEM_ALFABANK = 'alfabank';
  public static readonly PAYMENT_SYSTEM_FONDY = 'fondy';
  public static readonly PAYMENT_SYSTEM_IPAY = 'ipay';
  public static readonly PAYMENT_SYSTEM_TEST = 'test';
  public static readonly PAYMENT_SYSTEM_BE_PAID = 'bepaid';
  public static readonly PAYMENT_SYSTEM_PAYSELECTION = 'payselection';
  public static readonly PAYMENT_SYSTEM_PAYANYWAY = 'payanyway';
  public static readonly PAYMENT_SYSTEM_LIQPAY = 'liqpay';
  public static readonly PAYMENT_SYSTEM_YIGIM = 'yigim';
  public static readonly PAYMENT_SYSTEM_KAPITALBANK = 'kapitalbank';
}
